var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-share-links__wrapper"},[_c('a-icon-list',{staticClass:"author-share-links",attrs:{"icons":_vm.icons,"icon-width":16,"icon-height":16,"open-in-new-tab":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }